import React, { Fragment } from "react"
import { Redirect } from "react-router-dom"
import IndexView from "./Index/View"
import CreateView from "./Create/View"
import DetailView from "./Detail/View"
import UpdateView from "./Update/View"

const RouteView = (props) => {
    const urlParams = new URLSearchParams(props.location.search)
    const page = urlParams.get("template-surat")

    if (!page) {
        return <IndexView {...props} />
    }

    if (page === "create") {
        return <CreateView {...props} />
    }

    if (page === "detail") {
        return <DetailView {...props} />
    }

    if (page === "update") {
        return <UpdateView {...props} />
    }

    return <Redirect to="?template-surat" />
}

export default RouteView
